import { COMMON, CART } from "constants/types";
import { api as normalAPI, authApi, serverApi, formData } from "../../utils";


export const pingAction = (name, referer) => () => {
	if(referer) {
		return normalAPI.post(`/shops/${name}/ping?v=${new Date().getTime()}`, formData({ referer }))
			.then(res => {
				if (res && res.status === 200) {
					return res
				} else {
					throw res
				}
			})
			.catch(err => {
				throw err
			})
	} else {
		return normalAPI.post(`/shops/${name}/ping?v=${new Date().getTime()}`)
			.then(res => {
				if (res && res.status === 200) {
					return res
				} else {
					throw res
				}
			})
			.catch(err => {
				throw err
			})
	}
}

export const eventRegister = (data) => () =>
	normalAPI.post(`/events/register`, formData(data))
		.then(res => {
			if (res && res.status === 200) {
				return res;
			} else {
				throw res;
			}
		})
		.catch(err => {
			throw err;
		});

export const refreshInvoice = (data) => () =>
	normalAPI.post(`/invoices/refresh`, formData(data))
		.then(res => {
			if (res && res.status === 200) {
				return res;
			} else {
				throw res;
			}
		})
		.catch(err => {
			throw err;
		});

export const salesContactForm = (data) => () =>
	normalAPI.post(`/sales/contact_form`, formData(data))
		.then(res => {
			if (res && res.status === 200) {
				return res;
			} else {
				throw res;
			}
		})
		.catch(err => {
			throw err;
		});

export const clearShopState = () => dispatch => {
	dispatch({
		type: COMMON.CLEAR_SHOP_STATE
	})
}

export const clearProductState = () => dispatch => {
	dispatch({
		type: COMMON.GET_PRODUCT_BY_ID,
		payload: {}
	})
	dispatch({
		type: COMMON.PRODUCT_NOT_FOUND,
		payload: false
	})
};

export const getGeneralShopInfo = (name, isServer) => (dispatch) => {

	let api = isServer ? serverApi : normalAPI;


	return api.get(`/shops/${name}?v=${new Date().getTime()}`)
		.then(res => {

			let { status, data } = res;


			if (status === 200) {

				if(name === "assets") {
					document.title = "Shop Not Found | paylixecommerce";
					dispatch({
						type: COMMON.SHOP_NOT_FOUND,
						payload: true
					});

					return {}
				} else {
					dispatch(clearShopState());

					dispatch({
						type: COMMON.GENERAL_SHOP_INFO,
						payload: data
					});

					return data
				}

			} else if (status === 301) {
				dispatch({
					type: COMMON.SHOP_REDIRECTED,
					payload: data.redirect_link
				});
				return {}
			} else if (status === 404) {
				document.title = 'Shop Not Found | paylixecommerce'
				dispatch({
					type: COMMON.SHOP_NOT_FOUND,
					payload: true
				})
				return {}
			} else if (status === 403) {
				document.title = 'Banned User | paylixecommerce'
				dispatch({
					type: COMMON.SHOP_BANNED,
					payload: true
				})
			} else if (status === 500) {
				document.title = 'Waiting for API response | paylixecommerce'
				dispatch({
					type: COMMON.SHOP_IS_OFFLINE,
					payload: JSON.stringify(res, Object.getOwnPropertyNames(res || {}))
				});
				return {}
			} else {
				document.title = 'Shop Error | paylixecommerce'
				dispatch({
					type: COMMON.SHOP_IS_OFFLINE,
					payload: JSON.stringify(res, Object.getOwnPropertyNames(res || {}))
				})
				return {}
			}

		})
		.catch((error) => {
			document.title = 'Shop Error | paylixecommerce';
			dispatch({
				type: COMMON.SHOP_IS_OFFLINE,
				payload: JSON.stringify(error, Object.getOwnPropertyNames(error || {}))
			});
			throw error
		})
}

export const getGeneralShopInfoByDomain = (name, isServer) => (dispatch) => {

	let api = isServer ? serverApi : normalAPI;

	let config = {};
	if(isServer) {
		config = {
			headers: {
				"X-Paylix-Client-IP": isServer
			}
		}
	}

	return api.get(`/shops/domain/${name}?v=${new Date().getTime()}`, config)
		.then((res) => {
			let { status, data, error } = res;

			if (status === 200) {

				dispatch(clearShopState());

				dispatch({
					type: COMMON.GENERAL_SHOP_INFO,
					payload: data
				});

				return data
			} else if (status === 301) {
				dispatch({
					type: COMMON.SHOP_REDIRECTED,
					payload: data.redirect_link
				});
				return {}
			} else if (status === 404) {
				document.title = 'Shop Not Found | paylixecommerce';
				dispatch({
					type: COMMON.SHOP_NOT_FOUND,
					payload: true
				});
				return {}
			} else if (status === 403) {
				document.title = 'Shop Banned | paylixecommerce';
				dispatch({
					type: COMMON.SHOP_BANNED,
					payload: true
				});
				return {}
			} else if (status === 400 && error === "Seller subscription has expired.") {
				document.title = 'Shop Expired | paylixecommerce';
				dispatch({
					type: COMMON.SHOP_EXPIRED,
					payload: true
				});
				return {}
			} else if (status === 500) {
				document.title = 'Waiting for API response | paylixecommerce';
				dispatch({
					type: COMMON.SHOP_IS_OFFLINE,
					payload: JSON.stringify(error, Object.getOwnPropertyNames(error || {}))
				});
				return {}
			} else {
				document.title = 'Shop Error | paylixecommerce';
				dispatch({
					type: COMMON.SHOP_IS_OFFLINE,
					payload: JSON.stringify(error, Object.getOwnPropertyNames(error || {}))
				})
				return {}
			}
		})
		.catch((error) => {
			document.title = 'Shop Error | paylixecommerce';
			dispatch({
				type: COMMON.SHOP_IS_OFFLINE,
				payload: JSON.stringify(error, Object.getOwnPropertyNames(error || {}))
			})
			throw error
		})
}

export const doSearch = (string) => (dispatch) => {

	return authApi.get(`/search/${string}`)
		.then(res => {

			let { status, data } = res;

			if (status === 200) {

				return res;

			} else {
				throw res
			}
		})
		.catch(err => {
			throw err
		})
};

export const getBundles = (id, products) => (dispatch) => {
	return normalAPI.get(`/product_bundles/best?shop_id=${id}&products=${products}`)
		.then(res => {

			let { status, data } = res;

			if (status === 200) {

				dispatch({
					type: COMMON.ADD_BUNDLE,
					payload: data.bundles
				});

				return res;

			} else if (status === 404) {
				return res
			} else {
				throw res
			}
		})
		.catch(err => {
			throw err
		})
};


export const getInvoice = (id, isServer) => (dispatch) => {

	let api = isServer ? serverApi : normalAPI;

	return api.get(`/invoices/unique/${id}`)
		.then(res => {

			let { status, data } = res;

			if (status === 200) {

				dispatch({
					type: COMMON.GET_INVOICE_BY_ID,
					payload: data.invoice
				});

				return res;
			} else {
				throw res
			}
		})
		.catch(err => {
			throw err
		})
};


export const getPaymentLink = (id, isServer) => (dispatch) => {

	let api = isServer ? serverApi : normalAPI;

	return api.get(`/public/payment_links/${id}`)
		.then(res => {

			let { status, data } = res;

			if (status === 200) {

				dispatch({
					type: COMMON.GET_PAYMENT_LINK_BY_ID,
					payload: data
				});

				return res;
			} else {
				throw res
			}
		})
		.catch(err => {
			throw err
		})
};

export const getSubscription = (id, isServer) => (dispatch) => {

	let api = isServer ? serverApi : authApi;

	return api.get(`/invoices/unique/${id}`)
		.then(res => {

			let { status, data } = res;

			if (status === 200) {

				dispatch({
					type: COMMON.GET_INVOICE_BY_ID,
					payload: data.invoice
				});

				return res;
			} else {
				throw res
			}
		})
		.catch(err => {
			throw err
		})
}

export const getProduct = (id, isServer) => (dispatch) => {

	let api = isServer ? serverApi : normalAPI;

	return api.get(`/products/unique/${id}`).then(res => {

		let {status, data} = res;

		if (status === 200) {
			dispatch({
				type: COMMON.GET_PRODUCT_BY_ID,
				payload: {
					...data.product
				}
			});

			return res
		} else if (status === 404 || status === 400) {
			dispatch({
				type: COMMON.PRODUCT_NOT_FOUND,
				payload: true
			});
			return res
		} else {
			throw res
		}
	})
		.catch(err => {
			throw err
		})
}

export const getGroup = (id, isServer) => (dispatch) => {

	let api = isServer ? serverApi : normalAPI;

	return api.get(`/groups/unique/${id}`).then(res => {

		let {status, data} = res;

		if (status === 200) {
			dispatch({
				type: COMMON.GET_GROUP_BY_ID,
				payload: {
					...data.group
				}
			});

			return res
		} else if (status === 404 || status === 400) {
			dispatch({
				type: COMMON.GROUP_NOT_FOUND,
				payload: true
			});
			return res
		} else {
			throw res
		}
	})
		.catch(err => {
			throw err
		})
}

export const getBatchProduct = (ids) => (dispatch) => {

	return normalAPI.get(`/products/batch/${ids}`).then((res) => {

		let {status, data} = res;

		if (status === 200) {

			dispatch({
				type: CART.UPDATE,
				payload: data.products
			});

			return res
		} else {
			throw res
		}
	}).catch(err => {
		throw err
	})
}

export const getFeedbackById = (id) => () => {

	return normalAPI.get(`/feedback/unique/${id}`)
		.then(res => {
			if (res && res.status === 200) {
				return res
			} else {
				throw res
			}
		})
		.catch(err => {
			throw err
		})
}

export const createInvoice = (data, token) => () => {

	let headers = token ? { 'Authorization': `Bearer ${token}`} : {};

	return normalAPI.post('/invoices/create', formData(data), { headers, timeout: 60000 })
		.then(res => {
			if (res && res.status === 200) {
				return res
			} else {
				throw res
			}
		})
		.catch(err => {
			throw err
		})
}

export const setSubdomain = () => dispatch => {
	dispatch({
		type: COMMON.IS_CUSTOM_DOMAIN
	})
}

export const setPermission = (permission) => (dispatch) => {
	dispatch({
		type: COMMON.SET_PERMISSION,
		payload: permission
	})
}
